import { Component } from '@angular/core';

@Component({
	selector: 'app-content-auth',
	templateUrl: './content-auth.component.html',
	styleUrls: ['./content-auth.component.scss']
})
export class ContentAuthComponent {}
